import React, { useEffect } from 'react'

import FormSelectMargin from '../partials/FormSelectMargin'
import FormInputMargin from '../partials/FormInputMargin'

export default function FlacsQuestions (props) {


  let requireOptions = [
    "Choose an option below",
    "Yes (always)",
    "Yes (only with CRI)",
    "Optional (always offered)",
    "Optional (only offered with CRI)",
    "No (don't offer)",
  ]



  return (
    <div>
      <FormSelectMargin
        label={'Use FLACS for this lens?'}
        value={props.lensFlacsRequire}
        setHook={props.setLensFlacsRequire}
        options={requireOptions}
      />
    </div>
  )
}
